import { Injectable } from '@angular/core';
import { UrlService } from '@uirouter/core';

import { API }      from '../../api/api.constant';
import { ApiModel } from '../../api/models/api.model';

@Injectable({
  providedIn: 'root'
})
export class DomainParserService {
  _API     : ApiModel = API;

  constructor(
    private urlService : UrlService
  ) {}

  getDomain ( country : string ) : string {
    switch ( country ) {
      case 'can':
        return this._API.domains.can;
      case 'gbr':
        return this._API.domains.gbr;
      case 'usa':
        return this._API.domains.usa;
      default:
        return this._API.domains.aus;
    }
  }

  getHostname () : string {
    const hostname  = this.urlService.config.host();
    const subdomain = new RegExp(`${ this._API.subdomain }\.`, 'g');

    return this.isHttps()
      ? hostname.replace(subdomain, '')
      : hostname;
  }

  getPath () : string {
    return window.location.pathname
      .replace(/^\//, '');
  }

  isCountry ( country : string ) : boolean {
    const domain = this.urlService.config.host();

    return API.domains[country].indexOf(domain) > -1;
  }

  isHttps () : boolean {
    return this.urlService.config.protocol() === 'https';
  }

  isInternetExplorer () : boolean {
    const ua = window.navigator.userAgent;

    return ua.indexOf('MSIE ') > 0
      || ua.indexOf('Trident/') > 0
      || ua.indexOf('Edge/') > 0;
  }
}
